import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../service/context";
import { IntegrationBookingInputComponent } from "./Integration";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

const IntegrationBooking = () => {
  const [component, setComponent] = useState([]);
  const [updatedcomp, setUpdatedComp] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const ctx = useContext(UserContext);
  const { token } = ctx.user;
  useEffect(() => {
    getBookingByActivityAssignmentId();
  }, []);
  console.log("component", component);
  const getBookingByActivityAssignmentId = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/booking/update/activityassignment/${state.activity_assignment_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const obj = res.data.data;
        let result = Object.entries(obj).map(([key, value]) => ({
          label: key,
          value: value,
        }));
        setComponent(result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const renderInput = (comp, index) => {
    const props = {
      ...comp,
      index,
      onChange: handleChange,
      // onClick: handleButton,
    };
    return <IntegrationBookingInputComponent {...props} />;
  };
  const handleChange = (e, index) => {
    console.log("comp", component);
    var arr = [...component];
    arr[index].value = e.target.value;

    setUpdatedComp(arr);
  };
  const IntegrationUpdateBooking = () => {
    const arr = updatedcomp;
    const comp = {};
    arr.map((ele) => {
      comp[ele.label] = ele.value;
    });

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/booking/update/activityassignment/${state.activity_assignment_id}`,
        comp,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Booking Template updated successfully."
              onClick={() =>
                navigate(`/assignment/assign/${state.activity_assignment_id}`)
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          IntegrationUpdateBooking();
        }}
        className="overflow-y-auto flex-auto"
      >
        {component.length > 0
          ? component.map((comp, index) => {
              return renderInput(comp, index);
            })
          : null}
        {component.length !== 0 ? (
          <div className="flex justify-end space-x-2 mt-2">
            <button
              className="btn bg-rose-500 hover:bg-rose-600 text-white"
              onClick={(e) => {
                e.preventDefault();
                navigate("/booking/overview");
              }}
            >
              Cancel
            </button>
            <button
              className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
              type="submit"
            >
              Save and Next
            </button>
          </div>
        ) : null}
      </form>
    </div>
  );
};
IntegrationBooking.auth = { path: "/booking/integration", role: "super-admin admin" };

export default IntegrationBooking;
